
<div *ngIf="latestCampign!=null && latestCampign.length > 0" class="top-deals-carousel">
    <h2 class="text-center mb-4">{{ 'LatestCampaign' | translate }}</h2>
    <owl-carousel-o class="arabic-direction" [options]="customOptions">
        <ng-template carouselSlide *ngFor="let slide of latestCampign | slice:0:5; let i=index" [id]="slide.campaignID">

         <img
        [src]="attachmnetService.getImageLink(slide.originalCampaignID,AttachmentScopesEnum.Campaign,AttachmentTypeEnum.MemberShipBanners)"
        (click)="openCampaignLink(slide.landingPageURL)" [alt]="slide.campaignName" [title]="slide.campaignName">

        </ng-template>
    </owl-carousel-o>
</div>


